import { Resource, ResourceInfo, ResourceProps } from 'omni-package-react-core';
import React from 'react';
import { AccountConsents } from '../../interfaces/AccountConsents';
import { getProfileApiRoot } from '../../utils/getProfileApiRoot';

export const AccountConsentsResourceInfo: ResourceInfo = {
  name: '/App.features.termsOfUse.accountConsentsResource',
  dataDst: '/App.features.termsOfUse.termsOfUseConsents',
};

const AccountConsentsResource = <Data, Error = {}>({ ...props }: ResourceProps<Data, Error>) => (
  <Resource
    {...AccountConsentsResourceInfo}
    {...props}
    url={`${getProfileApiRoot()}/account/consents`}
    transformResponse={(data: AccountConsents) => data}
  />
);
export default AccountConsentsResource;
